import Cookies from "js-cookie"

export function deviceIdMigration() {
  const preKey = "hackleDeviceId"
  const newKey = "_hackle_hid"

  const id = localStorage.getItem(preKey) || Cookies.get(preKey)
  if (id && !Cookies.get(newKey)) {
    setUserId(newKey, id)
  }
}

export function setUserId(key: string, id: string) {
  const [top, second] = window.location.hostname.split(".").reverse()
  const domain = `.${second}.${top}`
  Cookies.set(key, id, { expires: 99999, domain: domain })
}
